import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Neraca',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Neraca',
        href: '/adm/fin/laporan/laba-rugi',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeNeraca(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getNeraca({ commit, state }) {
    commit('changeNeraca', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/neraca`, data.form);
    commit('changeNeraca', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
